export const CHANGE_ALERT_VISIBLE = 'change_alert_visible'
export const CHANGE_ALERT_TYPE = 'change_alert_type'
export const CHANGE_ALERT_TEXT = 'change_alert_text'

export function changeAlertVisible(visible) {
  return {
    type: CHANGE_ALERT_VISIBLE,
    payload: visible
  }
}

export function changeAlertType(type) {
  return {
    type: CHANGE_ALERT_TYPE,
    payload: type,
  }
}

export function changeAlertText(text) {
  return {
    type: CHANGE_ALERT_TEXT,
    payload: text,
  }
}

export function setAlert(type, text) {
  return dispatch => {
    dispatch(changeAlertVisible(true))
    dispatch(changeAlertType(type))
    dispatch(changeAlertText(text))
  }
}
